import * as Httprequest from '@/api/request.js'
export default {
  apiRuleTypeList (callback) {
    Httprequest.get('/dict/enum/front/apiRuleTypes').then((res) => {
      if (res.status === 200) {
        callback(res.data)
      }
    })
  },
  apiRuleTypeObj (callback) {
    Httprequest.get('/dict/enum/front/apiRuleTypes').then((res) => {
      if (res.status === 200) {
        const obj = {}
        res.data.forEach((item) => {
          obj[item.key] = item.value
        })
        callback(obj)
      }
    })
  }
}
